var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronUp = function SvgChevronUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2052",
    "data-name": "Grupo 2052",
    transform: "translate(-671 -664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_8",
    "data-name": "Uni\\xE3o 8",
    d: "M21587.9,14912.911a1.98,1.98,0,0,1-1.111-.276l-9.857-5.833a2.115,2.115,0,0,1-.744-2.847,2,2,0,0,1,2.775-.759l8.951,5.3,8.953-5.3a2,2,0,0,1,2.773.759,2.112,2.112,0,0,1-.742,2.847l-9.857,5.833a1.989,1.989,0,0,1-1.016.28C21587.98,14912.915,21587.939,14912.913,21587.9,14912.911Z",
    transform: "translate(-20904.914 -14231.914)",
    fill: "#cccb87"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1157",
    "data-name": "Ret\\xE2ngulo 1157",
    width: 24,
    height: 24,
    transform: "translate(671 664)",
    fill: "none",
    opacity: 0
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-up.7106e919.svg";
export { ForwardRef as ReactComponent };